import { render, staticRenderFns } from "./company-jobs-archive.vue?vue&type=template&id=3aae0bc9"
import script from "./company-jobs-archive.vue?vue&type=script&lang=js"
export * from "./company-jobs-archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports